import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
export const AppInstallationContext = createContext(null);
export function AppInstallationProvider({ installation, children }) {
    return (_jsx(AppInstallationContext.Provider, { value: installation, children: children }));
}
/**
 * Get the current app installation obejct when called in an app context otheriwse returns null
 */
export function useAppInstallation() {
    return useContext(AppInstallationContext);
}
//# sourceMappingURL=AppInstallationProvider.js.map